module.exports = {
  title: 'Daily Nook 🦋',
  description: `
    When Animal Crossing first came out, I was hooked along with most of my friends.
    Being the completionist that I am, I had to make a tool for tracking active 
    fish and bugs, as well as keeping track of what I've already caught.
  `,
  tags: ['CSS', 'Design', 'Firebase', 'JavaScript', 'React', 'Redux'],
  images: [require('./images/1.png'), require('./images/2.png'), require('./images/3.png')],
  url: 'https://daily-nook.web.app/',
};



// WEBPACK FOOTER //
// ./src/data/works/dailynook/index.js